import popupBlock from "./popup-block.js";
import popupCloseBlock from "./popup-close-block.js";
import popupTriggerBlock from "./popup-trigger-block.js";

const addBlocks = (editor, options) => {

  popupBlock(editor, options);
  popupTriggerBlock(editor, options);
  popupCloseBlock(editor, options);
}

export default addBlocks;